import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';

@Injectable({
  providedIn: 'root'
})
export class AgentService {
  allAgents: any;
  allActiveAgents: any;
  agent: any;

  constructor(private http: HttpClient) {}

  getAllAgents(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/agents/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            this.allAgents = response[0];
            resolve(this.allAgents);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getAllActiveAgents(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/agents/get-all`).subscribe({
        next: (response: any) => {
          this.allActiveAgents = response;
          resolve(this.allActiveAgents);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  getAgentByID(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/agents/get/${id}`).subscribe({
        next: (response: any) => {
          this.agent = response;
          resolve(this.agent);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  createAgent(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/agents/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.agent = response;
            resolve(this.agent);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateAgent(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/agents/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.agent = response;
            resolve(this.agent);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
